<template>

  <v-card class="pa-6 ma-md-10 bg-white-show-through">

    <!-- title -->
    <v-card-title class="card-title">
      <v-icon large class="indigo--text mr-3">{{ $t('sadmin.email_server_config.icon') }}</v-icon>
      {{ $t('sadmin.email_server_config.title') }}
    </v-card-title>

    <v-divider class="my-4"></v-divider>

    <v-card-text>

      <v-row>

        <AppAlert :alert="alert"/>

        <v-skeleton-loader v-if="isReady" v-bind="attrs" type="date-picker"></v-skeleton-loader>

        <v-col v-if="!isReady && config" cols="12">
          <v-form ref="form">
            <v-row>

              <!-- mail host -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailHost"
                    :rules="[v => !!v || 'Mail host is required']"
                    :label="$t('sadmin.email_server_config.host_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail port -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailPort"
                    :rules="[v => !!v || 'mail port is required']"
                    type="number"
                    :label="$t('sadmin.email_server_config.port_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail protocole -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailProtocole"
                    :rules="[v => !!v || 'mail protocol is required']"
                    :label="$t('sadmin.email_server_config.protocol_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail starttls -->
              <v-col cols="12" md="4" sm="6">
                <v-switch
                    v-model="config.mailStartTLS"
                    :label="$t('sadmin.email_server_config.start_tls_label')"
                    color="indigo"
                    inset>
                </v-switch>
              </v-col>

              <!-- mail username -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailUserName"
                    :rules="[v => !!v || 'mail username is required']"
                    :label="$t('sadmin.email_server_config.username_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail password -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailPassword"
                    :label="$t('sadmin.email_server_config.password_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail auth -->
              <v-col cols="12" md="4" sm="6">
                <v-switch
                    v-model="config.mailAuth"
                    :label="$t('sadmin.email_server_config.auth_label')"
                    color="indigo"
                    inset>
                </v-switch>
              </v-col>

              <!-- mail factory class -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailSocketFactoryClass"
                    :rules="[v => !!v || 'mail socket factory class is required']"
                    :label="$t('sadmin.email_server_config.socket_factory_class_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail debug -->
              <v-col cols="12" md="4" sm="6">
                <v-switch
                    v-model="config.mailDebug"
                    :label="$t('sadmin.email_server_config.debug_label')"
                    color="indigo"
                    inset>
                </v-switch>
              </v-col>

              <!-- mail from -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailFrom"
                    :rules="[v => !!v || 'mail from is required']"
                    :label="$t('sadmin.email_server_config.from_label')"
                    required>
                </v-text-field>
              </v-col>

              <!-- mail label form -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailLabelFrom"
                    :rules="[v => !!v || 'mail label from is required']"
                    :label="$t('sadmin.email_server_config.from_design_label')"
                    required>
                </v-text-field>
              </v-col>

            </v-row>

            <v-row>
              <!-- mail copyTo -->
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.mailCopyTo"
                    :rules="[v => !!v || 'mail copy to is required']"
                    :label="$t('sadmin.email_server_config.copy_to_label')"
                    required>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                    v-model="config.repondreA"
                    :rules="[v => !!v || 'repondreA to is required']"
                    :label="$t('sadmin.email_server_config.repondreA')"
                    required>
                </v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"/>

            <!-- validate config -->
            <v-btn color="success" class="mt-4" @click="validateConfig()">
              <v-icon class="mr-3">mdi-content-save-cog</v-icon>
              {{ $t('sadmin.email_server_config.save_btn_label') }}
            </v-btn>

          </v-form>
        </v-col>
      </v-row>

    </v-card-text>

  </v-card>

</template>

<script>
import { Alert } from '@/shared/models'
import { AppConfigApi } from '../../../shared/services/api/app-config'

export default {
  data () {
    return {
      config: null,
      isLoading: false,
      isReady: false,
      alert: null,
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2
      }
    }
  },
  methods: {
    validateConfig () {
      this.isLoading = false
      this.alert = null
      return AppConfigApi.saveEmailServerConfig(this.config)
          .then(emailServerConfig => {
            this.config = emailServerConfig
            this.alert = new Alert({
              type: 'success',
              message: this.$t('sadmin.email_server_config.success_message')
            })
          })
          .catch(error => this.alert = error)
          .finally(() => this.isLoading = false)
    },
    getConfig () {
      this.isReady = true
      this.alert = null
      AppConfigApi.getEmailServerConfig()
          .then(emailServerConfig => this.config = emailServerConfig)
          .catch(error => {
            this.alert = new Alert({
              type: 'error',
              color: 'red',
              text: error.message
            })
          })
          .finally(() => this.isReady = false)
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.box {
  margin-bottom: 0.4rem;
}
</style>
